import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const LoginService = (payload: LoginType) => {
  return HTTP_CLIENT.post(Endpoint.auth.login, payload);
};
const ForgotPasswordService = (payload: ForgotPasswordType) => {
  return HTTP_CLIENT.post(Endpoint.auth.forgotPassword, payload);
};
const ResetPasswordService = (payload: ResetPasswordType) => {
  return HTTP_CLIENT.post(Endpoint.auth.resetPassword, payload);
};
const RefreshTokenService = (refreshToken: string) => {
  return HTTP_CLIENT.post(Endpoint.auth.refreshToken, { refreshToken });
};

export {
  LoginService,
  ForgotPasswordService,
  ResetPasswordService,
  RefreshTokenService,
};
